import "../page";
import { createRoot } from "react-dom/client";
import "./index.css";
import { lazy, Suspense } from "react";
import NetworxProviders from "../../providers/NetworxProviders";
import { ThemeProvider as NextThemesProvider } from "next-themes";

import "./mock/mock-window";

import ToastTray from "../../components/ToastTray";
import { AB_TESTS } from "./utils/ab-tests-names";
import { getABTests } from "@/utils/ab-tests/ab-tests";
import * as Sentry from "@sentry/react";
import { Spinner } from "@nextui-org/react";
import { ServiceQuoteFlowErrorBoundary } from "./components/ErrorBoundry";

// Lazy load versions
const SQFControlNewEngine = lazy(
  () => import("./versions/control-new-engine/ServiceQuoteFlow"),
);
const SQFControl = lazy(() => import("./ServiceQuoteFlow"));

const domNode = document.getElementById("app");
if (!domNode) {
  throw new Error("Could not find the app root element");
}
const root = createRoot(domNode);

const versionToShow = (() => {
  const abTests = getABTests();
  if (abTests.get(AB_TESTS.ST_NEWBRANDING_COLOR_LOGO).isCompare) {
    return AB_TESTS.ST_NEWBRANDING_COLOR_LOGO;
  }
  if (abTests.get(AB_TESTS.ST_FLOW_CALLBUTTON).isCompare) {
    return AB_TESTS.ST_FLOW_CALLBUTTON;
  }
  return "CONTROL";
})();

const themeForVersion = {
  [AB_TESTS.ST_NEWBRANDING_COLOR_LOGO]: "new-branding",
  [AB_TESTS.ST_FLOW_CALLBUTTON]: "new-branding",
  CONTROL: "new-branding",
} satisfies Record<typeof versionToShow & {}, string>;

Sentry.setTags({
  page: "Service Quote Flow",
  "AB Test": versionToShow,
});

root.render(
  <NetworxProviders>
    <ServiceQuoteFlowErrorBoundary>
      <NextThemesProvider
        attribute="class"
        forcedTheme={versionToShow ? themeForVersion[versionToShow] : undefined}
      >
        <ToastTray />
        <Suspense
          fallback={
            <div className="h-screen w-screen flex items-center justify-center">
              <Spinner />
            </div>
          }
        >
          <SQFControlNewEngine />
        </Suspense>
      </NextThemesProvider>
    </ServiceQuoteFlowErrorBoundary>
  </NetworxProviders>,
);
